(() => {
  'use strict';

  if (window.AdobeReviewsData) return;

  const widgetSelector = '.template-product .jdgm-review-widget';

  function widget() {
    return document.querySelector(widgetSelector);
  }

  function roots(container = widget()) {
    if (!container) return [];
    return Array.from(container.querySelectorAll('.jdgm-rev-widg'));
  }

  function liveRoot(container = widget()) {
    const candidates = roots(container);
    const visible = candidates.filter((root) => {
      const style = window.getComputedStyle(root);
      return root.getClientRects().length > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    });

    return (
      visible.find((root) => !root.closest('.jdgm-legacy-widget-content')) ||
      visible[0] ||
      candidates.find((root) => !root.closest('.jdgm-legacy-widget-content')) ||
      null
    );
  }

  function sourceRoot(container = widget()) {
    return container?.querySelector('.jdgm-legacy-widget-content .jdgm-rev-widg') || liveRoot(container);
  }

  function number(value, fallback = 0) {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function rating(container = widget()) {
    const root = liveRoot(container);
    const source = sourceRoot(container);
    return number(
      root?.dataset.averageRating ||
      source?.dataset.averageRating ||
      root?.querySelector('.jdgm-rev-widg__summary-average')?.textContent,
      0
    );
  }

  function reviewCount(container = widget()) {
    const root = liveRoot(container);
    const source = sourceRoot(container);
    return number(root?.dataset.numberOfReviews || source?.dataset.numberOfReviews, 0);
  }

  function distribution(container = widget()) {
    const root = liveRoot(container) || sourceRoot(container);
    if (!root) return [];

    return Array.from(root.querySelectorAll('.jdgm-histogram__row[data-rating]'))
      .filter((row) => row.dataset.rating !== 'null')
      .map((row) => ({
        row,
        rating: number(row.dataset.rating),
        percentage: number(row.dataset.percentage),
        frequency: number(row.dataset.frequency)
      }));
  }

  function currentPage(container = widget()) {
    const root = liveRoot(container);
    const current = root?.querySelector('.jdgm-paginate__page.jdgm-curt, .jdgm-paginate__page[aria-current="page"]');
    return number(current?.dataset.page || current?.textContent, 1);
  }

  window.AdobeReviewsData = {
    widget,
    liveRoot,
    sourceRoot,
    rating,
    reviewCount,
    distribution,
    currentPage
  };

  document.dispatchEvent(new CustomEvent('adobe-reviews:data-ready'));
})();
